import { mergeStyles } from 'src/_shared/utils/mergeStyles';
import { TextIconButtonPersonalizedStyles, TextIconButtonProps } from './TextIconButton.types';

export function withPersonalizedTextIconButtonStyle<T extends TextIconButtonProps>(
  Component: React.ComponentType<T & TextIconButtonPersonalizedStyles>,
  styles: TextIconButtonPersonalizedStyles,
) {
  return ({
    style,
    innerStyle,
    disabledStyle,
    focusStyle,
    hoverStyle,
    pressedStyle,
    iconStyle,
    iconDisabledStyle,
    iconFocusStyle,
    iconHoverStyle,
    iconPressedStyle,
    textStyle,
    textDisabledStyle,
    textFocusStyle,
    textHoverStyle,
    textPressedStyle,
    ...props
  }: T) => {
    return (
      <Component
        style={mergeStyles(styles.button, style)}
        innerStyle={mergeStyles(styles.buttonInner, innerStyle)}
        disabledStyle={mergeStyles([styles.buttonDisabled, disabledStyle])}
        focusStyle={mergeStyles([styles.buttonFocus, focusStyle])}
        hoverStyle={mergeStyles([styles.buttonHover, hoverStyle])}
        pressedStyle={mergeStyles([styles.buttonPressed, pressedStyle])}
        iconStyle={mergeStyles(styles.icon, iconStyle)}
        iconDisabledStyle={mergeStyles([styles.iconDisabled, iconDisabledStyle])}
        iconFocusStyle={mergeStyles([styles.iconFocus, iconFocusStyle])}
        iconHoverStyle={mergeStyles([styles.iconHover, iconHoverStyle])}
        iconPressedStyle={mergeStyles([styles.iconPressed, iconPressedStyle])}
        textStyle={mergeStyles(styles.text, textStyle)}
        textDisabledStyle={mergeStyles([styles.textDisabled, textDisabledStyle])}
        textFocusStyle={mergeStyles([styles.textFocus, textFocusStyle])}
        textHoverStyle={mergeStyles([styles.textHover, textHoverStyle])}
        textPressedStyle={mergeStyles([styles.textPressed, textPressedStyle])}
        {...props}
      />
    );
  };
}
